import src from "IMAGE";
export default { src, width: 1756, height: 394, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANElEQVR42i3HoQ0AIAxFwT8WEskQGCQjMAJBICGp66R9ouLESZKjoWBio2LkZfi4WDh4+R7bRgdnQPJAywAAAABJRU5ErkJggg=="};
